import { render, staticRenderFns } from "./FollowCascader.vue?vue&type=template&id=03a1d0f1"
import script from "./FollowCascader.vue?vue&type=script&lang=js"
export * from "./FollowCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports